import * as React from 'react';
import { Button, Form } from '@built/design-system';
import Input, {
  addSubtext,
  addLabel,
  isWrapped,
  InputProps
} from './InputOverride';
import { ReactComponent as Visible } from '@built/design-system/icons/action/visibility.svg';
import { ReactComponent as Hidden } from '@built/design-system/icons/action/visibility_off.svg';

export class Password extends React.Component<PasswordProps, PasswordState> {
  constructor(props: PasswordProps) {
    super(props);
    this.state = { showPassword: false };
  }

  render() {
    const wrapped = isWrapped(this.props);
    const { showPassword } = this.state;
    const { className, label, aside, style, subtext, ...inputProps } =
      this.props;

    const input = (
      <Form.Group
        className={wrapped ? undefined : className}
        style={wrapped ? undefined : style}
      >
        <Input
          {...inputProps}
          autoComplete={'off'}
          type={showPassword ? 'text' : 'password'}
        />
        <Button
          icon={showPassword ? <Visible /> : <Hidden />}
          buttonType="secondary"
          size={this.props.size}
          onClick={this.handleClick}
        />
      </Form.Group>
    );

    return addLabel(addSubtext(input, this.props), this.props);
  }

  handleClick = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };
}

export interface PasswordProps extends InputProps {}

export interface PasswordState {
  showPassword: boolean;
}
